import { Component, ElementRef, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SidebarComponent } from '../../../@vex/components/sidebar/sidebar.component';
import { getCopyrightName } from 'src/static-data/location-variables';
import { DeviceInfoService } from 'src/services/device-info.service';
import { LegalComponent } from 'src/app/pages/legal/legal.component';
import { MatDialog } from '@angular/material/dialog';
import { PolicyComponent } from 'src/app/pages/policy/policy.component';
import { Subscription } from 'rxjs';
import { ScrollService } from 'src/services/scroll.service';
import { CustomizationStoreService } from 'src/services/customization.store.service';

@UntilDestroy()
@Component({
  selector: 'vex-widget-boxed-layout',
  templateUrl: './widget-boxed-layout.component.html',
  styleUrls: ['./widget-boxed-layout.component.scss']
})
export class WidgetBoxedLayoutComponent {
  @ViewChild('configpanel', { static: true }) configpanel: SidebarComponent;
  @ViewChild('widgetCard') widgetCard : ElementRef;
  @ViewChild('contentArea') contentArea!: ElementRef<HTMLElement>;

  private sub!: Subscription;

  copyrightName = '';
  showCopyright = false;
  isScaled$;
  isScaled = false;

  linkLabel = {
    'es': 'Aviso Legal',
    'en': 'Legal Notice',
    'it': 'Avviso Legale',
    'fr': 'Mentions Légales',
    'ca': 'Avís Legal',
    'de': 'Rechtlicher Hinweis',
    'pt': 'Aviso Legal'
  };
  lang = 'es';

  constructor(
    private customizationStore: CustomizationStoreService,
    public dialog: MatDialog,
    private scrollService: ScrollService
  ) { }

  ngOnInit() {
    this.copyrightName = getCopyrightName();
    this.customizationStore.getLang().subscribe(l => {
      this.lang = l;
    })

    this.sub = this.scrollService.scrollMainTop$.subscribe(() => {
      if (!this.contentArea) return;
      this.contentArea.nativeElement.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }

  gotoPolicy(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dialog.open(PolicyComponent, {
      panelClass: 'fullscreen-dialog',
    });
  }

  gotoLegal(e) {
    e.preventDefault();
    e.stopPropagation();
    this.dialog.open(LegalComponent, {
      panelClass: 'fullscreen-dialog',
      data: {
        lang: this.lang,
      },
    });
  }

}
